<template>
  <div :class="classes">
    <div class="vi-help--item__title">
      <b>功能介绍</b>
    </div>
    <div class="vi-help-features--text">
      <p>{{data && data.dataDetail || '暂无'}} </p>
    </div>
    <div class="vi-help--item__more" @click="onToPath">
      <a href="javascript:">了解更多</a>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  const prefixCls = 'vi-help-features'
  export default {
    name: 'vi-help-features',
    data () {
      return {}
    },
    props: {
      data: {
        type: Object,
        default: () => {}
      }
    },
    methods: {
      onToPath () {
        window.open(`${global.helpToDomain}features/${this.helpParams.reId}`)
      }
    },
    watch: {},
    beforeCreate () {
    },
    created () {
    },
    beforeMount () {
    },
    mounted () {
    },
    beforeUpdate () {
    },
    updated () {
    },
    beforeDestroy () {
    },
    destroyed () {
    },
    computed: {
      ...mapState('common', ['helpParams']),
      classes () {
        return [
          `${prefixCls}`
        ]
      }
    },
    components: {}
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  $-prefix-cls: "vi-help-features";
  .#{$-prefix-cls} {
    &--text {
      p {
        font-size: 14px;
        color: #999999;
        line-height: 18px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/js/module/layout/_source/helpFeatures.vue